<template>
  <v-container class="login" fluid fill-height>
    <v-layout sm6>
      <v-card class="logo-image"></v-card>
    </v-layout>
    <v-layout sm6 align-center justify-center wrap class="login-block">
      <v-flex xs12 sm8 md7>
        <v-card class="login-card">
          <h1 class="login-title">Login</h1>
          <v-card-text>
            <v-form>
              <v-text-field type="email" placeholder="Email" autocomplete="username" v-model="form.email" @input="$v.form.email.$touch()" @blur="$v.form.email.$touch()" :error-messages="getFormErrorMessage('email')"></v-text-field>
              <v-text-field type="password" placeholder="Password" autocomplete="current-password" v-model="form.password" @input="$v.form.password.$touch()" @blur="$v.form.password.$touch()" :error-messages="getFormErrorMessage('password')"></v-text-field>

              <v-btn class="login-btn primary" @click="handleSubmitForm()">
                Log in<v-icon class="right-arrow">arrow_forward</v-icon>
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
        <v-footer absolute class="footer">
          <v-layout justify-center row wrap>
            <v-flex xs12>Powered by ScanTrust™</v-flex>
          </v-layout>
        </v-footer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import router from '@/router'
import { getAuthToken } from '@/services/AuthService'
import AxiosInstances from '@/utils/axios.instances.js'
import { getFirstAllowedTab } from '@/utils/permissions'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  data () {
    return {
      form: {
        email: '',
        password: ''
      }
    }
  },
  validations () {
    return {
      form: {
        email: { required, email },
        password: { required }
      }
    }
  },
  methods: {

    getFormErrorMessage (field) {
      let errors = []

      if (!this.$v.form[field].$dirty) return errors
      for (let key in this.$v.form[field].$params) {
        // Add more key here is needed for other type of error messages
        if (key === 'required') !this.$v.form[field].required && errors.push('This field is is required.')
        if (key === 'email') !this.$v.form[field].email && errors.push('Please enter a valid email address.')
      }

      return errors
    },

    handleSubmitForm () {
      if (this.$v.form.$invalid) {
        this.$v.form.$touch()
      } else {
        this.submitLogin()
      }
    },

    submitLogin () {
      this.$store.dispatch('login', { email: this.form.email, password: this.form.password }).then(() => {
        const authToken = getAuthToken()
        AxiosInstances.setSTAuthToken(authToken)
        this.$store.dispatch('getUserProfile').then(() => {
          router.replace(getFirstAllowedTab())
        })
      }).catch((err) => {
        if (err.response.status === 400) {
          this.$store.dispatch('showSnackBar', { message: 'Unable to login with the provided credentials.' })
        } else {
          this.$store.dispatch('showSnackBar', { message: 'Server error, please try again later.' })
        }
      })
    }

  }
}

</script>

<style lang="scss" scoped>
.login{
  padding: 0px;
  .logo-image{
    height: 100%;
    width: 100%;
    background: url('../assets/images/login-image@2x.jpg') no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .login-block{
    position: relative;
    .login-card{
      border-radius: 18px;
      border: solid 1px #bbbbbb;
      padding: 14px;
      box-shadow: 0 0 0;
      .login-title{
        padding-left: 16px;
        font-size: 36px;
        font-weight: normal;
      }
      .login-btn{
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        .right-arrow{
          position: absolute;
          right: 0;
        }
      }
    }
    .footer{
      text-align: center;
      font-style: italic;
      font-size: 14px;
      color: #1f5fac;
      background: none;
      margin-bottom: 29px;
    }
  }
}
</style>
